<div class="row my-row">
    <aside class="col-md-3 my-col" id="sticky-sidebar">
        <div class="sidenav bd-sidebar">
            <ul class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <li class="nav-item">
                    <a [ngClass]="this.router.url == '/settings/user' ? 'nav-link active' : 'nav-link'" [routerLink]="'user'">
                        <em class="bi bi-person"></em>
                        <span class="mx-1" style="vertical-align: top;">{{ "SETTINGS.SIDE-MENU.ACCOUNT-LINK" | translate }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="this.router.url == '/settings/folders' ? 'nav-link active' : 'nav-link'" [routerLink]="'folders'">
                        <em class="bi bi-folder"></em>
                        <span class="mx-1" style="vertical-align: top;">{{ "SETTINGS.SIDE-MENU.FOLDERS-LINK" | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </aside>

    <div class="col-12 col-md-9 my-col" id="main">
        <router-outlet></router-outlet>
    </div>
</div>
